import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ParagraphsData } from './paragraphs.component';


@Component({
    selector: 'paragraphs-recursive',
    template: `
        <div *ngFor="let paragraph of data.paragraphs_list; let i = index" class="paragraph paragraph-{{i}}">
            <tag-text *ngIf="paragraph.title" class="paragraph-title" [data]="paragraph.title"></tag-text>

            <p *ngIf="paragraph.text" class="paragraph-text -eva-3-tc-gray-1" [innerHTML]="paragraph.text"></p>

            <paragraphs-recursive *ngIf=paragraph.paragraphs_list [data]=paragraph class="sub-paragraph sub-paragraph-{{i}}"></paragraphs-recursive>

            <eva-button *ngIf="paragraph.button_options" [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                [options]="paragraph.button_options"></eva-button>
<!--          deprecated tom-->
          <eva-button *ngIf="paragraph.link && paragraph.link_title && !paragraph.button_options" [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                      [options]="{ size: '-md', type: '-link', link: paragraph.link, link_text: paragraph.link_title}"></eva-button>
        </div>
    `,
    styleUrls: ['./paragraphs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ParagraphsRecursiveComponent {
    @Input() moduleId: string;
    @Input() moduleIndex: number;
    @Input() uniqueId?: string;
    @Input() data: ParagraphsData;

    constructor() {
    }
}
